import {Component, inject, OnInit} from '@angular/core';
import {PatientManagementService} from '../../patient-management.service';
import {AppointmentDto} from '../../../../shared/dtos/appointment.dto';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {DatePipe, Location} from '@angular/common';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {PatientDto} from '../../dtos/patient.dto';
import {LocationDetailDto} from '../../../startup/dtos/location-detail.dto';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {MatDialog} from '@angular/material/dialog';
import {CancelAppointmentDialog} from '../../dialogs/cancel-appointment/cancel-appointment.dialog';
import {AppointmentHistoryEntryDto} from '../../../../shared/dtos/appointment-history-entry.dto';
import {MatIconModule} from '@angular/material/icon';
import {ErrorService} from '../../../../core/services/error.service';
import {HttpErrorResponse} from '@angular/common/http';
import {AppointmentTypePipe} from '../../pipes/appointment-type-pipe';
import {CustomDatePipe} from '../../../../shared/pipes/custom-date-pipe';

// The appointment history action codes this page reports on.
const actionDeleted = 2;
const actionCancelled = 7;

@Component({
  selector: 'app-appointment-details',
  imports: [
    IconButtonComponent,
    TranslocoPipe,
    TextButton,
    MatIconModule,
    AppointmentTypePipe,
    CustomDatePipe
  ],
  templateUrl: './appointment-details.component.html',
  styleUrl: './appointment-details.component.scss'
})
export class AppointmentDetailsComponent implements OnInit {
  patientManagementService = inject(PatientManagementService);
  translocoService = inject(TranslocoService);
  location = inject(Location)
  dialog = inject(MatDialog)
  errorService = inject(ErrorService);

  locationDetailDto?: LocationDetailDto;
  appointmentDto?: AppointmentDto;

  appointmentHistory: AppointmentHistoryEntryDto[] = [];

  get patientDto(): PatientDto | undefined {
    return this.patientManagementService.patientDto;
  }

  ngOnInit() {
    this.appointmentDto = this.patientManagementService.selectedAppointmentDto;
    this.locationDetailDto = this.patientManagementService.locationDetailDtos?.find(l => l.locationId == this.appointmentDto?.locationId);
    // Cancelling an appointment deletes it as well, so the two entries describe one event and only
    // the cancellation is reported. Deletions are reported when nothing cancelled them.
    const historyEntries = this.appointmentDto?.historyEntries ?? [];
    const cancelledEntries = historyEntries.filter(h => h.action == actionCancelled);
    this.appointmentHistory = cancelledEntries.length > 0 ? cancelledEntries : historyEntries.filter(h => h.action == actionDeleted);
  }

  back() {
    this.location.back();
  }

  cancel() {
    this.dialog.open(CancelAppointmentDialog, {autoFocus: false, data: {appointmentDto: this.appointmentDto!}}).afterClosed().subscribe((success: boolean) => {
      if (success) {
        this.patientManagementService.selectedAppointmentDto = undefined;
        this.patientManagementService.appointmentDtos = undefined;
        this.location.back();
      }
    });
  }

  hide() {
    this.patientManagementService.hideAppointment(this.appointmentDto!.appointmentId).subscribe({
      next: () => {
        this.patientManagementService.selectedAppointmentDto = undefined;
        this.patientManagementService.appointmentDtos = undefined;
        this.location.back();
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error, this.translocoService.translate('error.title.hide'));
      }
    });
  }
}
